import { AreaType } from "@sparkware/uc-sdk-core";
import { CHANNEL_SOURCE, CHANNEL_ELEMENTS } from "../../../../../common/const/casinofied-analytics-consts";
import { DeepLinkActionBase } from "../deep-link-action-base";

export class FreeToPlayDeeplinkAction extends DeepLinkActionBase {
  async execute() {
    // user must be logged in to be F2P eligible!
    if(!this.services.user.isAuthorized){
      await this.services.user.openLogin({}, this.descriptor.marketingParams);
    }

    if (!this.services.freeToPlay.isPromotionEligible) {
      return Promise.reject('Free to play is not eligible for this user!');
    }

    let gaAction = "Direct_Widget_Launch";

    const specificParams: any = {};
    const id = this.descriptor.actionParams.id;

    /*
    deeplink={"action":"free-to-play","id":"unspecified/1/2"}
    no id - miniArena
    1 = dailywhish game
    2 = deposit wheel
    */

    // TODO - to be revisited after F2P widget is final
    switch (id) {
      case "1":
        specificParams.openDirectGame = true;
        gaAction = "Direct_Game_Launch";
        break;
    }

    this.services.analytics.sendAnalytics("F2P", gaAction, "Deeplink");

    await this.services.freeToPlay.showPromotion({
      channel: {
          area: AreaType.externalClick,
          source: CHANNEL_SOURCE.casinoClient,
          element: CHANNEL_ELEMENTS.deepLink
      },
      appSpecificParameters: specificParams
    });
  }
}